import * as React from 'react';
import PaidInvoiceView from '../layouts/PaidInvoiceView';
import { PaidInvoiceData } from 'src/reducers/paidinvoice';

export interface PaidInvoicePageProps {
  onComponentDidMount: () => void;
  onComponentWillMount: () => void;
  paidInvoiceData: PaidInvoiceData[];
  dateFilter: (filterStartdate: Date, filterEnddate: Date) => void;
  dateReset: (filterStartdate: Date, filterEnddate: Date) => void;
  printReceipt: (txn: PaidInvoiceData) => void;
}

class PaidInvoicePage extends React.Component<PaidInvoicePageProps> {
  render() {
    return (
      <div>
        <PaidInvoiceView
          paidInvoiceData={this.props.paidInvoiceData}
          dateFilter={this.props.dateFilter}
          dateReset={this.props.dateReset}
          printReceipt={this.props.printReceipt}
        />
      </div>
    );
  }
  componentDidMount() {
    this.props.onComponentDidMount();
  }
  componentWillMount() {
    // const url: string = window.location.href;
    this.props.onComponentWillMount();
  }
}

export default PaidInvoicePage;



// WEBPACK FOOTER //
// ./src/components/PaidInvoice/PaidInvoicePage.tsx